import React from 'react'

const FactCounter = () => {
  return (
    <>
         <section className="facts-area section-gap" id="facts-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 single-fact">
                <h1 className="counter">6</h1>
                <p>Products Shipped</p>
              </div>
              <div className="col-lg-3 col-md-6 single-fact">
                <h1 className="counter">700</h1>
                <p>Screens Shipped</p>
              </div>
              <div className="col-lg-3 col-md-6 single-fact">
                <h1 className="counter">5</h1>
                <p>Industries Served</p>
              </div>
              <div className="col-lg-3 col-md-6 single-fact">
                <h1 className="counter">30,000</h1>
                <p>Records Managed Live</p>
              </div>
            </div>
          </div>
        </section>

    </>
  )
}

export default FactCounter